/*
Setzt Matomo-Title und -URL der aktuellen Seite und sendet den Page View bei
Client-Side-Navigation.

Der Page View eines server-geladenen Aufrufs kommt vom Matomo-Bootstrap in
TrackingCodes. Dieser Bootstrap sendet nur `trackPageView` — Title und URL muss
diese Komponente vorher in die `_paq`-Queue schreiben, sonst fällt Matomo auf
`document.title` zurück und `customTitle` (z. B. `Event - <slug>`) fehlt im
Report. Die Reihenfolge stimmt, weil Cookiebot erst nach der Hydration geladen
wird (siehe CookiebotLoader) und das Bootstrap-Script damit nach diesem Effect
läuft.

Einen eigenen Page View sendet die Komponente nur bei Client-Side-Navigation —
siehe claimOwnPageView() —, damit der server-geladene Aufruf nicht doppelt zählt.

Alles läuft über die `_paq`-Queue, es wird also nichts vor dem Statistik-Consent
gesendet. Seiten, die vor der Consent-Entscheidung wieder verlassen werden, tauchen
deshalb in keinem Report auf — bewusste Lücke, siehe docs/tracking-consent.md.
*/

'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import {
  MATOMO_METHODS,
  claimOwnPageView,
  getTrackedUrl,
  pushMatomo,
} from '@/utils/matomo';

export default function MatomoPageView({ customTitle }: { customTitle?: string }) {
  const pathname = usePathname();

  useEffect(() => {
    pushMatomo(
      [MATOMO_METHODS.SET_DOCUMENT_TITLE, customTitle || document.title],
      [MATOMO_METHODS.SET_CUSTOM_URL, getTrackedUrl()],
    );

    if (claimOwnPageView()) {
      pushMatomo([MATOMO_METHODS.TRACK_PAGE_VIEW]);
    }
  }, [pathname, customTitle]);

  return null;
}
